import {
  newAxios
} from '.'
const userId = true

export const Req_GetReportList = data => {
  return newAxios({
    url: `/stu/exam/transcript/list`,
    userId
  })()
}

export const Req_CreateExamDetail = data => {
  return newAxios({
    url: `/stu/exam/create`,
    data,
    userId
  })()
}

export const Req_SubmitExam = data => {
  return newAxios({
    url: `/stu/exam/web/submit`,
    data,
    userId
  },'json')()
}

export const Req_GetExamReport = data => {
  return newAxios({
    url: `/stu/exam/transcript`,
    data
  })()
}


export const Req_GetTopcList = data => {
  return newAxios({
    url: `/stu/question/farming/list`,
    data
  })()
}


// WEBPACK FOOTER //
// ./src/ajax/exam.js